import ImageText from "./ImageText";

export default ImageText;
